import { WebSocketMessageTypeOutgoing } from "../../../Enums/WebSocketMessageTypeOutgoing";

export class WsDeviceUpdate{
    public Type!: WebSocketMessageTypeOutgoing

    constructor(){
        this.Type = WebSocketMessageTypeOutgoing.WsDeviceUpdate;
    }
}